module.exports = __webpack_public_path__ + "img/product_80.b8e3c9e.webp";